<template lang="pug">
v-container.pa-8(style="max-width:1080px")
  div.d-flex.justify-center.mt-16(v-if="isFetching")
    v-progress-circular(:width="2" :size="50" color="primary" indeterminate)

  template(v-else)
    v-row(no-gutters align="center")
      v-col.shrink
        v-btn.ml-n3(text icon @click="clickBack" height)
          v-icon(color="basic800" :size="24") mdi-arrow-left
      v-col.ml-3
        p.mb-0.h6.basic800--text {{ $t('create_new_provider') }}

    v-form(ref="form")
      provider-details
      v-divider.basic500.my-5
      provider-availability
      v-divider.basic500.my-5
      provider-service(@addNewProvider="addNewProvider")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProviderDetails from '@/components/clinic/manage/ProviderDetails.vue'
import ProviderAvailability from '@/components/clinic/manage/ProviderAvailability.vue'
import ProviderService from '@/components/clinic/manage/ProviderService.vue'

export default {
  name: 'Provider',
  components: { ProviderDetails, ProviderAvailability, ProviderService },
  props: ['id'],
  data () {
    return {
      isFetching: false,
      manageTab: 0
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      form: 'clinic/getForm',
      tempProvider: 'clinic/getTempProvider'
    }),
  },
  mounted () {
    if (this.id) {
      this.fetchProvider()
    }
  },
  provide () {
    return {
      getRef: this.$refs
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchProvider () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/providers/${this.id}`)
        .then(resp => {
          this.$store.commit('clinic/setProvider', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    addNewProvider () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all')])
        return
      }
      this.$store.commit('clinic/updateTempLoading', true)
      var params = new FormData()
      if (this.tempProvider.profile_image) {
        params.append('profile_image', this.tempProvider.profile_image)
      }
      let data = JSON.parse(JSON.stringify(this.tempProvider))
      delete data.profile_image
      const endpoint = `/clinics/${this.company.slug}/providers`
      this.$axios.post(endpoint, data)
        .then(resp => {
          this.updateActivityLog(endpoint, data, resp, 'POST')
          if (this.tempProvider.profile_image) {
            let provId = resp.data.id
            this.$axios.patch(`/clinics/${this.company.slug}/providers/${provId}`, params)
              .catch(() => {
                this.showMessage(['error', this.$t('error_message.unable_to_upload_image')])
              })
              .finally(() => {
                this.$store.commit('clinic/resetTempProvider')
                this.$router.push('/admin/clinic/manage')
                this.$store.commit('clinic/updateTempLoading', false)
              })
          } else {
            this.$store.commit('clinic/resetTempProvider')
            this.$router.push('/admin/clinic/manage')
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          if (!this.tempProvider.profile_image) {
            this.$store.commit('clinic/updateTempLoading', false)
          }
        })
    },
    clickBack () {
      this.$router.go(-1)
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'provider',
        activity: 'Create new provider',
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  },
  destroyed () {
    this.$store.commit('clinic/resetProvider')
    this.$store.commit('clinic/resetTempProvider')
  }
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>